<template >
  <div>
    <div class="formPosition">
      <template>
        <v-row no-gutters>
          <v-col>
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>


            <!-- ============== sTART DIALOG ============== -->
            <v-dialog v-model="dialog" persistent max-width="600px">
              <v-card>
                <v-overlay :value="overlay2">
                  <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card-title style="background-color:#006699;color:white;">
                    <span class="text-h5">Nova Senha</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col md="12">
                          <small>*Identificou-se que é um novo usuário no sistema e a sua senha não foi registrada por sí,
                            para continuar deverá actualizar-la.</small>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field :type="hidePassword ? 'password' : 'text'"
                            :append-icon="hidePassword ? 'visibility_off' : 'visibility'" name="password" label="Password"
                            id="password" :rules="usernameRule" v-model="user.passwords"
                            @click:append="hidePassword = !hidePassword"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field :type="hidePassword2 ? 'password' : 'text'"
                            :append-icon="hidePassword2 ? 'visibility_off' : 'visibility'" name="password"
                            label="Password" id="password" :rules="usernameRule" v-model="user.passwordConfirmar"
                            @click:append="hidePassword2 = !hidePassword2"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="terminarSessao()">
                      Cancelar
                    </v-btn>
                    <v-btn color="green darken-1" :disabled="!valid" @click="mudarSenha()" style="color:white;">
                      Salvar senha
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <!-- ============== END DIALOG ============== -->








            <v-container style="background-color:white;border:1px solid #006699;">
              <v-row>
                <v-col md="6"></v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <clock></clock>
                </v-col>
              </v-row>
              <v-divider style="background-color:#cccccc;"></v-divider>
              <v-row>
                <v-col md="2">
                  <v-row>
                    <v-col md="3"></v-col>
                    <v-col md="6"><v-icon size="50" color="#006699">shopping_cart</v-icon></v-col>
                  </v-row>
                  <v-row>
                    <v-col md="2"></v-col>
                    <v-col md="10" style="font-size:20px;margin-top:-25px;">Vendas Hoje</v-col>
                  </v-row>
                </v-col>
                <v-divider style="background-color:#cccccc;" vertical></v-divider>
                <v-col md="3">
                  <v-card>
                    <v-row class="no-gutters">
                      <div class="col-auto">
                        <div class="cyan fill-height">&nbsp;</div>
                      </div>
                      <div class="col pa-3 py-4 cyan--text">
                        <h5 class="text-truncate text-uppercase">Vendas</h5>
                        <h1>{{ quantidadeVendas[0].quantidade }}</h1>
                      </div>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col md="3">
                  <v-card>
                    <v-row class="no-gutters">
                      <div class="col-auto">
                        <div class="primary fill-height">&nbsp;</div>
                      </div>
                      <div class="col pa-3 py-4 primary--text">
                        <h5 class="text-truncate text-uppercase">Vendas( Em Dinheiro )</h5>
                        <h1>{{ utilitarios.IntegerToMoneyValueFatura(quantidadeVendas[0].totalEmDinheiro) }}</h1>
                      </div>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col md="3">
                  <v-card>
                    <v-row class="no-gutters">
                      <div class="col-auto">
                        <div class="success fill-height">&nbsp;</div>
                      </div>
                      <div class="col pa-3 py-4 success--text">
                        <h5 class="text-truncate text-uppercase">Produtos</h5>
                        <h1>{{ quantidadeVendas[0].produtos }}</h1>
                      </div>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-row no-gutters style="margin-top:1px;">
          <v-container>
            <v-row>
              <v-col md="6">
                <v-card style="border:1px solid #006699;">
                  <v-card-title style="background-color:#2680a3;color:white;">Gráfico de Vendas -
                    {{ anoActual }}</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <bar v-bind:descricao="'Vendas'" v-bind:cor="'#f87979'"
                      v-bind:meses="(valor1.length <= 0) ? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] : [valor1[0].qtd, valor2[0].qtd, valor3[0].qtd, valor4[0].qtd, valor5[0].qtd, valor6[0].qtd, valor7[0].qtd, valor8[0].qtd, valor9[0].qtd, valor10[0].qtd, valor11[0].qtd, valor12[0].qtd]"
                      :height="300"></bar>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="6">
                <v-card style="border:1px solid #006699;">
                  <v-card-title style="background-color:#2680a3;color:white;">Gráfico de Compras -
                    {{ anoActual }}</v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <bar v-bind:descricao="'Entradas(em dinheiro existente no Stock)'" v-bind:cor="'#006699'"
                      v-bind:meses="[valor1s[0].DinheiroEntrada, valor2s[0].DinheiroEntrada, valor3s[0].DinheiroEntrada, valor4s[0].DinheiroEntrada, valor5s[0].DinheiroEntrada, valor6s[0].DinheiroEntrada, valor7s[0].DinheiroEntrada, valor8s[0].DinheiroEntrada, valor9s[0].DinheiroEntrada, valor10s[0].DinheiroEntrada, valor11s[0].DinheiroEntrada, valor12s[0].DinheiroEntrada]"
                      :height="300"></bar>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>







        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Bar from '../../components/Bar'
import clock from '../../components/relogioDigital'
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  components: { 'bar': Bar, 'clock': clock },
  data: () => ({
    timestamp: '',
    dialog: false,
    valid: true,
    quantidadeVendas: [],
    quantidadeMes: [],
    quantidadeEntradaStock: [],
    anoActual: utilitarios.ObterANOActual(),
    utilitarios: utilitarios,
    overlay: false,
    overlay2: false,
    valor1: [],
    valor2: [],
    valor3: [],
    valor4: [],
    valor5: [],
    valor6: [],
    valor7: [],
    valor8: [],
    valor9: [],
    valor10: [],
    valor11: [],
    valor12: [],
    valor1s: [],
    valor2s: [],
    valor3s: [],
    valor4s: [],
    valor5s: [],
    valor6s: [],
    valor7s: [],
    valor8s: [],
    valor9s: [],
    valor10s: [],
    valor11s: [],
    valor12s: [],
    hidePassword: true,
    hidePassword2: true,
    usernameRule: [
      // this.value.replace(/[^\d]/, ''),

      v => !!v || 'campo obrigatório.',
      v => {
        const pattern = /([^A-Za-z0-9])$/
        return !pattern.test(v) || 'Inválido.'
      }
    ],
    user: {
      passwords: '',
      passwordConfirmar: ''
    }
  }),

  computed: {

    licencaDiasRestantes() {
      return ls.get('diasRestantes')
    },

    myStyles() {
      return { height: '99px' }
    },

    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },
    anolectivo() {
      return ls.get('anolectivo')
    },
    loggedUserName() {
      return ls.get('nomeUsuario')
    },

    loggedUserName() {
      return ls.get('nomeUsuario')
    },

    mudarPassword() {
      return ls.get('mudarPassword')
    },


    role() {
      let rl = ''
      if (ls.get('role') === 'ROLE_GERENTE') {
        rl = 'logado como Gerente'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },


  created() {
    // console.log(ls.get('uuid'));




    // this.Call()
    this.timestamp = new Date()
    this.InitializeVendasHoje()
    this.QuantidadeVendaMes(1).then((res) => {
      this.valor1 = res
    })
    this.QuantidadeVendaMes(2).then((res) => {
      this.valor2 = res
    })
    this.QuantidadeVendaMes(3).then((res) => {
      this.valor3 = res
    })
    this.QuantidadeVendaMes(4).then((res) => {
      this.valor4 = res
    })
    this.QuantidadeVendaMes(5).then((res) => {
      this.valor5 = res
    })
    this.QuantidadeVendaMes(6).then((res) => {
      this.valor6 = res
    })
    this.QuantidadeVendaMes(7).then((res) => {
      this.valor7 = res
    })
    this.QuantidadeVendaMes(8).then((res) => {
      this.valor8 = res
    })
    this.QuantidadeVendaMes(9).then((res) => {
      this.valor9 = res
    })
    this.QuantidadeVendaMes(10).then((res) => {
      this.valor10 = res
    })
    this.QuantidadeVendaMes(11).then((res) => {
      this.valor11 = res
    })
    this.QuantidadeVendaMes(12).then((res) => {
      this.valor12 = res
    })
    this.QuantidadeEntradasCaixaMes(1).then((res) => {
      this.valor1s = res
    })
    this.QuantidadeEntradasCaixaMes(2).then((res) => {
      this.valor2s = res
    })
    this.QuantidadeEntradasCaixaMes(3).then((res) => {
      this.valor3s = res
    })
    this.QuantidadeEntradasCaixaMes(4).then((res) => {
      this.valor4s = res
    })
    this.QuantidadeEntradasCaixaMes(5).then((res) => {
      this.valor5s = res
    })
    this.QuantidadeEntradasCaixaMes(6).then((res) => {
      this.valor6s = res
    })
    this.QuantidadeEntradasCaixaMes(7).then((res) => {
      this.valor7s = res
    })
    this.QuantidadeEntradasCaixaMes(8).then((res) => {
      this.valor8s = res
    })
    this.QuantidadeEntradasCaixaMes(9).then((res) => {
      this.valor9s = res
    })
    this.QuantidadeEntradasCaixaMes(10).then((res) => {
      this.valor10s = res
    })
    this.QuantidadeEntradasCaixaMes(11).then((res) => {
      this.valor11s = res
    })
    this.QuantidadeEntradasCaixaMes(12).then((res) => {
      this.valor12s = res
    })



    if (this.mudarPassword === '1') {

      this.dialog = true

    }



  },

  methods: {

    async GetUserLocation() {
      return this.$getLocation()
        .then(coordinates => {
          return 'coordinates'
        })
    },

    terminarSessao() {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    Call() {
      console.log('============' + Object.values(this.GetUserLocation))
    },

    async InitializeVendasHoje() {
      try {
        this.quantidadeVendas = await axios
          .get('/QuantVendasHoje')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async mudarSenha() {

      if (this.$refs.form.validate()) {
        this.overlay2 = true
        if (this.user.passwords === this.user.passwordConfirmar) {
          try {

            let result = await axios.post('actualizarSenha', this.user).then(res => res.data)
            this.overlay2 = false
            if (result.affectedRows >= 1) {
              Swal.fire('A sua senha foi alterada com sucesso.', '', 'success')
              setTimeout(() => {
                this.terminarSessao()
              }, 1000);
            }

          } catch (error) {
            Swal.fire('Ocorreu um erro ao tentar efectuar a operação.', '', 'error')
          }
        } else {
          this.overlay2 = false
          Swal.fire('As senhas não correspondem.', '', 'warning')
        }


      }

    },

    async QuantidadeVendaMes(mes) {
      this.overlay = true

      try {
        this.quantidadeMes = await axios
          .get('/QuantVendasPorMes/' + mes)
          .then(res => res.data)
        if (this.quantidadeMes.length) {
          setTimeout(() => {
            this.overlay = false
          }, 4000)
        }
        return this.quantidadeMes
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async QuantidadeEntradasCaixaMes(mes) {
      this.overlay = true

      try {
        this.quantidadeEntradaStock = await axios
          .get('/QuantEntradasCaixaPorMes/' + mes)
          .then(res => res.data)
        if (this.quantidadeEntradaStock.length) {
          setTimeout(() => {
            this.overlay = false
          }, 4000)
        }
        return this.quantidadeEntradaStock
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    getNow() {
      const today = new Date()
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      const dateTime = date + ' ' + time
      this.timestamp = date
    }

  }
}
</script>
<style scoped\>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
